<template>
  <div>
    <v-text-field
      v-model="searchGenotypes"
      append-icon="search"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <v-data-table
      v-model="selectedGenotypes"
      dense
      :headers="headersGenotypes"
      :items="genotypes"
      :items-per-page="5"
      item-key="name"
      :show-select="showSelect"
      class="elevation-1"
      :search="searchGenotypes"
      :sort-by="'name'"
      :sort-desc="false"
    >
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    genotypes: {
      type: Array,
      default: function() {
        return [];
      },
    },
    showSelect: { type: Boolean, default: true },
  },
  data() {
    return {
      searchGenotypes: '',
      selectedGenotypes: [],
      headersGenotypes: [
        {
          text: 'genotype',
          align: 'left',
          sortable: true,
          value: 'name',
        },
        {
          text: 'allele',
          align: 'left',
          sortable: true,
          value: 'allele',
        },
        {
          text: 'fragment',
          align: 'left',
          sortable: true,
          value: 'fragment',
        },
      ],
    };
  },
  watch: {
    selectedGenotypes() {
      this.$emit('select-genotypes', this.selectedGenotypes);
    },
  },
};
</script>

<style></style>
